// 0 线下礼品 1 GPU券(仅限GPU，扣费时优先使用本券) 2 CPU券(仅限CPU，扣费时优先使用本券) 3 通用券 4 青云券(CPU青云平台专用) 6 青云券（GPU青云平台专用） undefined 免单券 8 云制作币
export enum CouponDetailType {
  Offline,
  GPU = 1,
  CPU,
  Universal,
  CPUQing,
  GPUQing = 6,
  Desktop = 8,
}
